import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Media from "../pages/media/page";
import Videos from "../pages/videos/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/media",
    element: <Media />,
  },
  {
    path: "/videos",
    element: <Videos />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;